<template>
<div>
    <v-list-item class="bottom-border" :style="`border-left: 5px solid ${status}`">
        <v-list-item-content>
            <v-list-item-title>{{title}}</v-list-item-title>
            <v-list-item-subtitle v-if="subtitle" class="word-wrap ml-n1">
                {{subtitle}}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="description">
                {{description}}
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <slot name="actions">
                <v-menu bottom left v-if="actions.length>0">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, i) in actions" :key="i" @click="$emit(item.event, item)">
                            <action-button :key="item.name" :icon="item.name" :show="isAllowed(item.permission)"></action-button>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </slot>
        </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
</div>
</template>

    
<script>
export default {
    props: {
        title: {
            type: String,
            default: () => ''
        },
        subtitle: {
            type: String,
            default: () => ''
        },
        description: {
            type: String,
            default: () => ''
        },
        actions: {
            type: Array,
            default: () => []
        },
        status:{
            type: String,
            default: () => 'PENDING'
        }
    }
}
</script>

    
<style lang="scss" scoped>
.word-wrap {
    white-space: break-spaces;
}

.SOLD {
    border-left: 5px solid green;
}

.PENDING {
    border-left: 5px solid orange;
}

.TRASHED {
    border-left: 5px solid red;
    margin: 1px 0px;
}

.bottom-border{
    border-bottom: 1px solid gray;
}
</style>
